import { defineComponent as w, useSlots as A, computed as t, useAttrs as B, createElementBlock as n, openBlock as d, normalizeClass as u, createElementVNode as _, renderSlot as T, mergeProps as z, createVNode as E, unref as x } from "vue";
import { usePropsValidation as S } from "../../composables/usePropsValidation.js";
import $ from "../../icons/generated/IconCheckLarge.vue2.js";
import { omit as P } from "../../utils/omit.js";
import { tw as a } from "../../utils/tailwind.js";
import { CHANGE_EVENT as W } from "./CheckboxBase.constant.js";
const j = ["id", "checked", "disabled", "value"], U = /* @__PURE__ */ w({
  name: "RevCheckboxBase",
  inheritAttrs: !1,
  __name: "CheckboxBase",
  props: {
    modelValue: { type: [Boolean, Array], default: !1 },
    disabled: { type: Boolean, default: !1 },
    isTransparent: { type: Boolean, default: !1 },
    id: {},
    label: {},
    value: { default: "on" },
    tickClassNames: { default: a`left-0 top-2` }
  },
  emits: ["change", "update:modelValue"],
  setup(f, { emit: p }) {
    const e = f, b = A(), o = p, i = t(() => !!b.default), s = t(() => !i.value), c = t({
      get() {
        return e.value && Array.isArray(e.modelValue) ? e.modelValue.includes(e.value) : e.modelValue;
      },
      set(l) {
        l !== e.modelValue && o("update:modelValue", l);
      }
    });
    function v(l) {
      if (o(W, l), typeof e.modelValue == "boolean") {
        o("update:modelValue", l.target.checked);
        return;
      }
      if (Array.isArray(e.modelValue)) {
        const r = l.target.checked ? [...e.modelValue, e.value] : e.modelValue.filter((N) => N !== e.value), g = Array.from(new Set(r));
        o("update:modelValue", g);
      }
    }
    S({
      "If no slot is passed, `props.label` is mandatory": () => s.value && !e.label
    });
    const h = t(() => {
      const l = B();
      return {
        ...P(l, ["class"]),
        ...s.value && e.label && {
          "aria-label": e.label
        }
      };
    }), k = t(() => [
      a`relative`,
      s.value && a`size-24`
    ]), C = t(() => [
      a`peer appearance-none outline-none`,
      i.value && a`sr-only`,
      s.value && a`absolute inset-x-0 bottom-0 top-2 size-20`,
      s.value && !e.disabled && a`cursor-pointer`,
      s.value && e.disabled && a`cursor-not-allowed`
    ]), m = t(() => [
      a`rounded-sm pointer-events-none absolute flex size-20 shrink-0 items-center justify-center`,
      e.disabled && a`bg-action-default-low-disabled`,
      s.value && "left-0 top-2 peer-focus-visible:outline-default-hi",
      e.tickClassNames
    ]), V = t(() => [
      a`border`,
      e.isTransparent ? a`bg-transparent` : a`bg-action-default-low peer-hover:bg-action-default-low-hover`,
      e.disabled ? a`border-action-default-hi-disabled` : a`border-action-default-hi`
    ]), y = t(() => [
      a`border border-transparent`,
      e.disabled ? a`text-onaction-default-low-disabled` : a`bg-action-default-low-pressed text-onaction-default-low-pressed peer-hover:bg-action-default-low-hoverpressed`
    ]);
    return (l, r) => (d(), n("div", {
      class: u([l.$attrs.class, k.value])
    }, [
      _("input", z({ id: l.id }, h.value, {
        checked: c.value,
        class: C.value,
        disabled: l.disabled,
        type: "checkbox",
        value: l.value,
        onChange: v
      }), null, 16, j),
      T(l.$slots, "default"),
      c.value ? (d(), n("div", {
        key: 0,
        class: u([m.value, y.value])
      }, [
        E(x($), {
          class: "motion-safe:animate-[fade_10ms_ease-in]",
          size: "16"
        })
      ], 2)) : (d(), n("div", {
        key: 1,
        class: u([m.value, V.value])
      }, null, 2))
    ], 2));
  }
});
export {
  U as default
};
